import React, { useEffect, useState } from 'react'
import { formatDateOnly } from '../../config/resources/utils'
import { fetchCurrentIndicators } from '../../services/indicators'
import LandingProductPreview from '../Landing/LandingProductPreview'
import {
  Carousel,
  Viewport,
  Track,
  Slide,
  IndicatorsCard,
  IndicatorsTitle,
  IndicatorsSubtitle,
  IndicatorGrid,
  IndicatorTile,
  IndicatorLabel,
  IndicatorValue,
  IndicatorMeta,
  Dots,
  Dot,
} from './AuthPreviewCarousel.styles'

const SLIDE_COUNT = 2
const AUTO_MS = 12000

const AuthPreviewCarousel = () => {
  const [index, setIndex] = useState(0)
  const [utm, setUtm] = useState(null)
  const [imm, setImm] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    fetchCurrentIndicators()
      .then((data) => {
        if (cancelled) return
        setUtm(data.utm)
        setImm(data.imm)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  useEffect(() => {
    const id = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % SLIDE_COUNT)
    }, AUTO_MS)
    return () => window.clearInterval(id)
  }, [])

  const immEffective = imm?.effectiveFrom
    ? formatDateOnly(imm.effectiveFrom)
    : null

  return (
    <Carousel>
      <Viewport>
        <Track $index={index}>
          <Slide>
            <LandingProductPreview standalone />
          </Slide>
          <Slide>
            <IndicatorsCard>
              <div>
                <IndicatorsTitle>Valores de referencia vigentes</IndicatorsTitle>
                <IndicatorsSubtitle>
                  UTM del SII e ingreso mínimo mensual (IMM) para calcular tu
                  pensión alimenticia.
                </IndicatorsSubtitle>
              </div>
              <IndicatorGrid>
                <IndicatorTile>
                  <IndicatorLabel>UTM</IndicatorLabel>
                  <IndicatorValue>
                    {loading ? '…' : utm?.value || '—'}
                  </IndicatorValue>
                  <IndicatorMeta>
                    {utm?.period
                      ? `Período ${utm.period}`
                      : 'Unidad Tributaria Mensual'}
                  </IndicatorMeta>
                </IndicatorTile>
                <IndicatorTile>
                  <IndicatorLabel>IMM</IndicatorLabel>
                  <IndicatorValue>
                    {loading ? '…' : imm?.value || '—'}
                  </IndicatorValue>
                  <IndicatorMeta>
                    {immEffective
                      ? `Vigente desde ${immEffective}`
                      : 'Ingreso Mínimo Mensual'}
                  </IndicatorMeta>
                </IndicatorTile>
              </IndicatorGrid>
            </IndicatorsCard>
          </Slide>
        </Track>
      </Viewport>
      <Dots role="tablist" aria-label="Vista previa">
        {Array.from({ length: SLIDE_COUNT }).map((_, slideIndex) => (
          <Dot
            key={slideIndex}
            type="button"
            role="tab"
            aria-selected={index === slideIndex}
            aria-label={
              slideIndex === 0
                ? 'Vista del panel'
                : 'Valores UTM e IMM vigentes'
            }
            $active={index === slideIndex}
            onClick={() => setIndex(slideIndex)}
          />
        ))}
      </Dots>
    </Carousel>
  )
}

export default AuthPreviewCarousel
